import { API_URL } from '../constants';
import { fetch } from '../fetchWrapper/fetch';
import { ProductSizedItemsResponseBody } from './types';
import type { TMenuItemType } from 'src/types/menu.types';

export const getProductSizedItems = async (
  itemId?: string,
  name?: string,
  limit: number = 15,
  type?: TMenuItemType[],
  ranges?: string[],
): Promise<ProductSizedItemsResponseBody> => {
  try {
    const urlWithParams = new URL(`${API_URL}/items/product-sizes?limit=${limit}`);

    if (itemId) {
      urlWithParams.searchParams.append('after_id', itemId);
    }

    if (name) {
      urlWithParams.searchParams.append('name', name);
    }

    if (type?.length > 0) {
      urlWithParams.searchParams.append('type', type.join(','));
    }

    if (ranges?.length > 0) {
      urlWithParams.searchParams.append('ranges', ranges.join(','));
    }

    const response = await fetch(urlWithParams.href);

    if (!response.ok) {
      throw new Error('We have been unable to complete your request. Please try again');
    }

    const json: ProductSizedItemsResponseBody = await response.json();

    return json;
  } catch (e) {
    throw new Error(e);
  }
};
